<template>
  <b-card title="Ürün Fotoğrafları">
    <b-row>
      <b-col
        v-for="(item,index) in dataList"
        :key="index"
        cols="12"
        md="4"
      >
        <image-card
          :item-key="index"
          :data-item="item"
          :get-data-list="getDataList"
        />
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import ImageCard from '@/views/Products/elements/GalleryCard/ImageCard.vue'

export default {
  name: 'GalleryCard',
  components: {
    BCard,
    BRow,
    BCol,
    ImageCard,
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
    dataList() {
      return this.$store.getters['productGallery/dataList']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.commit('products/SET_LOADING', true)
      this.$store.dispatch('productGallery/getDataList', this.$route.params.id)
        .then(response => {
          if (response) {
            this.$store.commit('products/SET_LOADING', false)
          }
        })
    },
  },
}
</script>
